export default __webpack_public_path__ + "54e289f192b06390fc580c74f3ee5382.json";